var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing"}},[(_vm.feed.length < 1)?_c('rtx-spinner',{staticClass:"page-spinner"}):_c('div',[_c('site-header'),_vm._v(" "),(_vm.isSingleEntry)?_c('div',[_c('entry',{attrs:{"entry":_vm.feed[0],"tileType":"single"}})],1):_c('div',[_c('tiles',{attrs:{"feed":_vm.feed}})],1),_vm._v(" "),_c('site-footer',{ref:"footerElement"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0d0d0f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/site/Landing.vue
// module id = dxWu
// module chunks = 1